import { render } from "./PartDetails.vue?vue&type=template&id=0aabd0e6"
import script from "./PartDetails.vue?vue&type=script&lang=js"
export * from "./PartDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__